import type { Permission } from '@/shared/constants';

import { usePermissions } from '../api';
import type { PermissionMode } from '../types';
import { useIsSuperUser } from './useIsSuperUser';

export const useHasPermission = (
	required: Permission | Permission[],
	mode: PermissionMode = 'all',
) => {
	const isSuperUser = useIsSuperUser();
	const { data: permissions, isLoading, isError } = usePermissions();

	if (isSuperUser) return { hasPermission: true, isLoading: false, isError: false };

	const hasPermission = permissions
		? (Array.isArray(required) ? required : [required])[mode === 'all' ? 'every' : 'some']((p) =>
				permissions.has(p),
			)
		: false;

	return { hasPermission, isLoading, isError };
};
